<template>
	<transition name="slide-up-down">
		<section class="institution-view" v-if="value">
			<div class="institution-inner">
				<div class="close" @click="$emit('input', null)"></div>
				<div class="institution-cover">
					<img v-if="inst.image_url" :src="inst.image_url" />
				</div>

				<div class="institution-header">
					<div class="header-flex">
						<img class="header-logo" :src="inst.logo_url" />
						<div class="header-text">{{ inst.name }}</div>
					</div>
					<div class="header-background">
						<img :src="inst.image_url" />
					</div>
				</div>

				<h3 class="institution-title">
					Help us {{ inst.full_impact_statement }}
				</h3>

				<div class="institution-description">
					{{ inst.description }}
				</div>
				<div v-if="inst.designations && inst.designations.length > 0">
					<div class="project-info">
						<p>Pick the area of need you'd like to give to.</p>
					</div>
					<selector
						:options="[
							{ title: '-', id: -1 },
							...inst.designations
						]"
						placeholder="Select Campaign"
						label="title"
						@input="handleProjectChange($event)"
					/>
				</div>

				<div class="institution-button">
					<ui-button @click="selectInstitution" :loading="loading"
						>Select Organization</ui-button
					>
				</div>
			</div>
		</section>
	</transition>
</template>

<script>
import { mapActions } from 'vuex'

import UiButton from '../../ui/Button'
import Selector from '../../ui/Selector.vue'

export default {
	name: 'institution-view',
	components: { UiButton, Selector },
	props: ['value'],
	data() {
		return {
			inst: this.value,
			loading: false,
			designation: null
		}
	},
	methods: {
		...mapActions([
			'attachInstitution',
			'getInstitution',
			'getCurrentUser',
			'pickDesignation'
		]),
		handleProjectChange(event) {
			this.designation = event
		},
		selectInstitution() {
			this.loading = true
			this.attachInstitution(this.inst)
				.then(() => (this.loading = false))
				.then(() => {
					if (this.designation && this.designation.id !== -1) {
						this.pickDesignation(this.designation.id)
					}
				})
				.then(() => {
					if (this.$route.name == 'settings.institution') {
						this.getCurrentUser()
						this.$swal(
							'Success',
							'Your organization has been changed successfully!'
						).then(() => {
							this.navigate({ name: 'home' }, 'forward')
						})
					} else {
						this.navigate(
							{
								name: 'mindonation',
								params: { onboarding: true }
							},
							'forward'
						)
					}
				})
				.catch((error) => {
					this.$swal(error.message)
				})
		}
	},
	watch: {
		value(newValue) {
			this.inst = newValue
			this.getInstitution(newValue.id).then((data) => {
				this.inst = data
			})
		}
	}
}
</script>

<style lang="scss">
.institution-view {
	position: fixed;
	bottom: 0px;
	left: 0px;
	height: 100%;
	width: 100%;
	background: rgba(0, 0, 0, 0.4);
	z-index: 999;
	padding-top: 30px;
	@media screen and (max-width: 480px) {
		padding-top: 20px;
	}
	.institution-inner {
		position: relative;
		top: 0px;
		border-radius: 20px 20px 0px 0px;
		background: $white;
		width: 100%;
		max-width: 480px;
		height: 100%;
		padding: 30px 20px 90px;
		overflow: auto;
		margin: 0 auto;
		.close {
			background: url('../../assets/close_dark.svg') no-repeat;
			width: 30px;
			height: 30px;
			margin-top: -10px;
			cursor: pointer;
			transition: all 0.2s ease-in-out;
			&:hover {
				transform: scale(1.1);
			}
		}
		.institution-cover {
			position: relative;
			height: 260px;
			border-radius: 12px 12px 0px 0px;
			overflow: hidden;
			img {
				height: 100%;
				max-width: 100%;
				-o-object-fit: cover;
				object-fit: cover;
				width: 100%;
			}
		}
		.institution-header {
			background: #000;
			position: relative;
			overflow: hidden;
			min-height: 80px;
			margin: -60px 0 0;
			border-radius: 0px 0px 12px 12px;
		}
		.header-background {
			position: absolute;
			bottom: -20px;
			margin-left: -25px;
			margin-right: -25px;
			-webkit-filter: blur(10px);
			filter: blur(10px);
			opacity: 0.9;
			z-index: 0;
			img {
				height: 100%;
				max-width: 100%;
				-o-object-fit: cover;
				object-fit: cover;
				width: 100%;
			}
		}
		.header-flex {
			position: relative;
			z-index: 1;
			display: flex;
			padding: 20px;
			.header-logo {
				position: relative;
				z-index: 1;
				max-width: 40px;
				max-height: 40px;
				flex-shrink: 0;
				border-radius: 6px;
			}
			.header-text {
				flex-grow: 1;
				color: $white;
				padding-left: 15px;
				font-weight: 600;
				font-size: 17px;
				display: flex;
				align-items: center;
			}
		}

		.institution-title {
			font-family: 'Bitter', serif;
		}
		.institution-button {
			position: fixed;
			bottom: 0px;
			left: 0px;
			width: 100%;
			padding: 20px;
			text-align: center;
		}
		button {
			max-width: 440px;
			margin: 0 auto;
			.institution-description {
				white-space: pre-wrap;
			}
		}
	}

	.project-info {
		background: rgba(37, 83, 205, 0.1);
		padding: 10px;
		border-radius: 10px;
		font-size: 18px;
		line-height: 18px;
		font-weight: 600;
		color: $navy;
	}
	p {
		margin: 0px;
	}
}

.project-chooser .vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
	background: #dfe5fb;
	border: none;
	color: #394066;
	text-transform: lowercase;
	font-variant: small-caps;
}

.vs__clear,
.vs__open-indicator {
	fill: #394066;
}

.vs__selected-options > input .vs__search {
	width: 100%;
}

.slide-up-down-enter {
	opacity: 0;
	backface-visibility: hidden;
	z-index: 1;
	.institution-inner {
		transform: translate(0, 100%);
	}
}
.slide-up-down-leave-active {
	opacity: 0;
	backface-visibility: hidden;
	z-index: 1;
	.institution-inner {
		transform: translate(0, 100%);
	}
}

.slide-up-down-enter-active,
.slide-up-down-leave-active,
.slide-up-down-enter-active .institution-inner,
.slide-up-down-leave-active .institution-inner {
	transition: all 250ms ease-in-out;
}
</style>
